import { render, staticRenderFns } from "./FileToUpload.vue?vue&type=template&id=1780d74b&scoped=true&"
import script from "./FileToUpload.vue?vue&type=script&lang=js&"
export * from "./FileToUpload.vue?vue&type=script&lang=js&"
import style0 from "./FileToUpload.vue?vue&type=style&index=0&id=1780d74b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1780d74b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
